import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { DocumentPost } from '../../models/document.model';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { url } from '../../assets/global';
import { Observable } from 'rxjs';
import { Post } from '../../models/post.model';

@Injectable()
export class DocumentsProvider {
    constructor(
        public api: Api,
        private androidPermissions: AndroidPermissions) { }

    async getDocumentPosts(eventId: string): Promise<any> {
        return this.api.get(`posts/findAll?postType=DOCUMENT&event=${eventId}&pageNumber=0&pageSize=30`).toPromise();
    }

    async getUserDocuments(eventName: string = ""): Promise<any> {
        return this.api.get(`documents/my?pageNumber=0&pageSize=30&eventName=${eventName}`).toPromise();
    }

    async uploadDocument(file: any): Promise<any> {
        const formData: FormData = new FormData();

        formData.append('file', file);

        return this.api.post(`documents/upload`, formData).toPromise();
    }

    async uploadCv(file: any): Promise<any> {
        const formData: FormData = new FormData();

        formData.append('file', file);

        return this.api.post(`user/upload/cv`, formData).toPromise();
    }



    public createDocument(cmd: DocumentPost): Promise<any> {
        return this.api.post(`posts/create`, cmd).toPromise();
    }

    public updateDocument(cmd: any): Promise<any> {
      return this.api.post(`posts/update`, cmd).toPromise();
    }

    downloadDocument(documentUrl: string): any {
        return this.api.downloadFile(documentUrl);
    }

    downloadDocumentWithUuid(documentUuid: string): any {
        return this.api.downloadFile(`${url}/documents/download/${documentUuid}`);
    }

    deleteCv(documentUuid: string): any {
      return Observable.fromPromise(
        this.api.delete(`user/delete/cv?documentUuid=${documentUuid}`, {})
      ).mergeMap(res => {
        return res;
      });
    }

}



// WEBPACK FOOTER //
// ./src/providers/documents/documents.ts